var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',_vm._g(_vm._b({staticClass:"input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update:value', $event.target.value)}}},'input',_vm.$attrs,false),_vm.on))])}
var staticRenderFns = []

export { render, staticRenderFns }